import {
    cancelBookingAction,
    pickupMileageAction,
    returnMileageAction,
    updateBookingAction,
} from "./actions.js";

import ItemView from "../../components/ItemView/ItemView.vue";

const appConfig = JSON.parse(import.meta.env.VITE_APP_CONFIG);

const formatDateTime = value => new Date(Number(value)).toLocaleString("en-GB", {
    dateStyle: "medium",
    timeStyle: "short",
});

const routes = [{
    "path": "/PoolCarBooking",
    "component": () => import("./PoolCarBooking.vue"),
    "name": "Pool Car Booking",
    "meta": {
        "app": "Pool Car Booking",
        "sideNav": true,
        "appSwitcher": true,
        "appSwitcherPosition": 5,
        "icon": "car",
        "name": "Pool Car Booking",
        "sideNavSection": "Pool Car Booking",
        "security": "General.User"
    }
}, {
    "path": "/PoolCarBooking/:id",
    "component": ItemView,
    "name": "Pool Car Booking Details",
    "meta": {
        "app": "Pool Car Booking",
        "sideNav": false,
        "icon": "car",
        "name": "Booking Details",
        "dataPathOverride": "PoolCarBooking/Bookings/:id",
        title(booking) {
            return booking?.Purpose || "Pool Car Booking";
        },
        "dataFields": [
            { "label": "Booking", "break": true, "class": "md:col-span-3" },
            { "label": "Start", compute: ({ pageItem }) => formatDateTime(pageItem?.Start) },
            { "label": "End", compute: ({ pageItem }) => formatDateTime(pageItem?.End) },
            { "label": "Booked By", "key": "UserName" },
            {
                "label": "Booking Created By",
                "key": "BookedByName",
                show({ pageItem }) {
                    return Boolean(pageItem?.BookedByName) && pageItem.BookedByName !== pageItem.UserName;
                },
            },
            { "label": "Purpose", "key": "Purpose" },
            { "label": "Commercial", "key": "Commercial" },
            { "label": "Created", "key": "Created", "type": "date" },
            { "label": "Mileage", "break": true, "class": "md:col-span-3" },
            {
                "label": "Pickup Mileage",
                compute: ({ pageItem }) => pageItem?.Mileage?.StartRecorded === true ? pageItem.Mileage.Start.Value : "Not recorded",
            },
            {
                "label": "Drop Off Mileage",
                compute: ({ pageItem }) => pageItem?.Mileage?.EndRecorded === true ? pageItem.Mileage.End.Value : "Not recorded",
            },
            {
                "label": "Distance",
                compute: ({ pageItem }) => pageItem?.Mileage?.Complete === true ? pageItem.Mileage.Distance : "Not available",
            },
        ],
        "menuActions": [
            updateBookingAction,
            pickupMileageAction,
            returnMileageAction,
            cancelBookingAction,
        ],
    }
}, {
    "path": "/PoolCarBooking/Mileage",
    "component": () => import("./MileageEntry.vue"),
    "name": "Pool Car Mileage",
    "meta": {
        "app": "Pool Car Booking",
        "icon": "gauge-high",
        "name": "Record Mileage",
        "sideNav": false,
        "sideNavPosition": 2,
        "sideNavSection": "Pool Car Booking",
    }
}];

export default appConfig.poolCarBooking?.enabled === false ? [] : routes;
